import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/utils";
import AdminLayout from "../../layouts/admin-panels/AdminLayout";

const UserAdminPanel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCookie("ColibriToken");
    if (!token) {
      navigate("/auth");
    }
  }, [navigate]);
  return (
    <div>
      <AdminLayout />
    </div>
  );
};

export default UserAdminPanel;
